import { Component } from '@angular/core';

@Component({
  selector: 'app-director-msg',
  templateUrl: './director-msg.component.html',
  styleUrls: ['./director-msg.component.scss']
})
export class DirectorMsgComponent {
  showChairmanMessage = false;
  showDirectorMessage = false;
  showPrincipalMessage = false;
}
